import styled, { css } from "styled-components";
import { TextStylesByVariant } from "./data";
import { TextProps } from "./types";

const getStyle = ({
    color,
    align,
    variant,
    uppercase,
    lineThrough,
    fullWidth,
    fontWeight,
    fontSize,
    underline,
}: TextProps) => {
    return css`
        color: ${color};
        text-align: ${align};
        font-size: ${fontSize ||
        TextStylesByVariant[variant || "body1"].fontSize};
        font-weight: ${fontWeight ||
        TextStylesByVariant[variant || "body1"].fontWeight};
        text-transform: ${uppercase ? "uppercase" : "initial"};
        text-decoration: ${lineThrough ? "line-through;" : "initial"};
        width: ${fullWidth && "100%"};
        text-decoration: ${underline ? "underline" : "none"};
    `;
};

export const StyledText = styled.span<TextProps>`
    cursor: ${({ as }) => as === "label" && "pointer"};
    font-family: "Montserrat", sans-serif;
    ${getStyle}
`;
